import type { FieldValues } from "react-hook-form"
import { FormTextField, type FormTextFieldProps } from "../FormTextField"

export type FormEmailFieldProps<TFieldValues extends FieldValues = FieldValues> =
  Omit<FormTextFieldProps<TFieldValues>, "type">

export const FormEmailField = <TFieldValues extends FieldValues = FieldValues>(
  props: FormEmailFieldProps<TFieldValues>,
) => <FormTextField<TFieldValues> {...props} type="email" />
